"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCursor02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M4.9 2.62c-.225-.081-.453-.163-.647-.213-.183-.048-.536-.127-.915.004a1.5 1.5 0 0 0-.927.927c-.131.38-.052.733-.005.916.05.193.133.421.214.647L8.349 20.86c.1.28.197.549.292.756.08.175.263.558.66.774a1.5 1.5 0 0 0 1.4.018c.403-.206.596-.583.68-.756.101-.204.205-.47.313-.748l2.578-6.631 6.632-2.58c.277-.107.543-.21.748-.311.172-.085.55-.278.756-.681a1.5 1.5 0 0 0-.018-1.4c-.217-.397-.6-.58-.774-.66-.207-.095-.476-.192-.756-.292L4.9 2.619Z", fill: "currentColor" }) }))); };
exports.default = SvgCursor02;
